// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__nvZ-Y","tabsItem":"Tabs_tabsItem__31sJg","active":"Tabs_active__3lmTW"};